import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import configureStore, { history } from './configureStore';
import { unregister } from './registerServiceWorker';
import registerScalingListener from './utils/registerScalingListener';
import { getThemeName } from './utils/themeUtils';
import { THEME_WCC } from './themes';
import configureApollo from './configureApollo';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSmoking,
  faSpinner,
  faCalendar,
  faChevronLeft,
  faChevronRight,
  faTimes,
  faCaretLeft,
  faCaretRight,
  faCaretDown,
  faCaretUp,
  faWheelchair,
  faCircle,
  faBan,
  faCamera,
  faLongArrowAltRight,
  faChevronCircleLeft,
  faChevronCircleRight,
  faSignInAlt,
  faArrowLeft,
  faSearch,
  faPlus,
  faMinus
} from '@fortawesome/free-solid-svg-icons';
import { faCircle as regularCircle } from '@fortawesome/free-regular-svg-icons';

library.add(
  faSmoking,
  faSpinner,
  faCalendar,
  faChevronLeft,
  faChevronRight,
  faTimes,
  faCaretLeft,
  faCaretRight,
  faCaretDown,
  faCaretUp,
  faWheelchair,
  faCircle,
  faBan,
  faCamera,
  faLongArrowAltRight,
  faChevronCircleLeft,
  faChevronCircleRight,
  regularCircle,
  faSignInAlt,
  faArrowLeft,
  faSearch,
  faPlus,
  faMinus
);

// unregister service worker if it's registered, to prevent major caching issues for now.
unregister();

// Get the theme name, and if it's wcc then register scaling listener.
const themeName = getThemeName();

// Add themename class to html and body tags.
document.documentElement.classList.add(`html-theme-${themeName}`);
document.body.classList.add(`body-theme-${themeName}`);

if (themeName === THEME_WCC) {
  registerScalingListener(document, window);
}

const store = configureStore();

// Create Apollo client.
const apolloClient = configureApollo(history);

ReactDOM.render(
  <App store={store} history={history} apolloClient={apolloClient} />,
  document.getElementById('root')
);

// Commenting out the service worker for now, as it causes massive caching issues and headaches...
//registerServiceWorker();
